<template>
    <div>

        <a-modal
          title="Warning"
          :visible="modalVisible"
          @ok="updatePlugin"
          @cancel="closeModal"
        >
            Changes on the plugin source code has been detected. Are you sure you want to override source?
        </a-modal>

        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <br> <br>
            <base-dropdown >
                <base-button slot="title" type="success" class="dropdown-toggle">
                    Plugin Manager - {{ _.startCase(selectedProfile)}}
                </base-button>
                <a @click.prevent="setCurrentProfile('pos_plugins')" class="dropdown-item" href="#">POS Plugins</a>
                <a @click.prevent="setCurrentProfile('backend_plugins')" class="dropdown-item" href="#">Backend Plugins</a>
            </base-dropdown>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">   
                    <div v-if="selectedProfile == 'pos_plugins'" class="card mb-3">
                      <div class="row no-gutters" style="height: 70vh; max-height: 70vh;">
                        <div class="col-md-4" style="border-right: 1px solid #e0e0e0">
                          <div class="card-body">
                            <div class="row">
                                <div class="col-md-8 no-gutters">
                                    <h3 class="card-title">POS Plugins</h3>
                                </div>

                                <div v-if="formVisble == false" class="col-md-4 float-right"><button @click="showPluginForm()" class="btn btn-sm btn-primary" style="border-radius: 24px; background-color: #0569FF; border:0px; width: 100%;"> + New</button></div>
                                <div v-if="formVisble == true" class="col-md-4 float-right">
                                    <a-popconfirm title='Are you sure you want to cancel?' class="btn btn-sm btn-danger" style="border-radius: 24px; border:0px; width: 100%;" @confirm="() => showPluginForm()">
                                        Cancel
                                    </a-popconfirm>
                                </div>

                                <div class="col-md-12" :key="pluginKey">
                                    <ul v-if="posPlugins.length > 0" class="list-group" style="width: 100%">
                                        <li class="list-group-item" style="font-size: 14px" v-for="posPlugin in posPlugins" :key=posPlugin.id @click="getPlugin(posPlugin.id)">
                                            {{posPlugin.name}} <br>
                                            <small>Author: {{posPlugin.author}}</small>   
                                        </li>
                                    </ul>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-8">
                          <div class="card-body">
                             <div class="row">
                                <div class="col-md-9"><h3 class="card-title">POS Plugin Configuration</h3></div>
                                <div v-if="formVisble == true" class="col-md-3 steps-action float-right">
                                    &nbsp; &nbsp;
                                    <button style="margin-left: 8px" @click="current--" class="btn btn-sm btn-primary" :disabled="current==0">
                                        Prev
                                    </button>
                                    <button v-if="current < steps.length - 1" type="primary" @click="current++" class="btn btn-sm btn-primary">
                                        Next
                                    </button>
                                    <button class="btn btn-sm btn-success" v-if="current == steps.length - 1 && plugin.id == undefined" type="primary" @click="createPlugin()">
                                        Save
                                    </button>
                                    <button class="btn btn-sm btn-success" v-if="current == steps.length - 1 && plugin.id != undefined" type="primary" @click="preUpdatePlugin()">
                                        Update
                                    </button>
                                </div>

                                <div class="col-md-12" v-if="formVisble == true" style="padding: 15px; width: 100%; max-height: 56vh; overflow: scroll;">
                                    <!-- <form> -->
                                        <a-steps :current="current">
                                          <a-step v-for="item in steps" :key="item.title" :title="item.title"/>
                                        </a-steps>
                                        <div class="steps-content">
                                            <br/><br/>
                                            <div v-if="current == 0">
                                                <h6 class="heading-small text-muted mb-4">Basic Details</h6>
                                                <div class="row">
                                                    <base-input required alternative="" label="Name" v-model="plugin.name" class="col-md-6"/>
                                                    <base-input required alternative="" label="Version" v-model="plugin.version" class="col-md-6"/>
                                                    <base-input required alternative="" label="Author Name" v-model="plugin.author" class="col-md-6"/>
                                                    <base-input required alternative="" label="Company Name" v-model="plugin.company" class="col-md-6" />
                                                </div>
                                            </div>
                                            <div v-if="current == 1">
                                                <a-upload-dragger
                                                  accept=".zip"
                                                  :remove="handleRemove"
                                                  :fileList="fileList"
                                                  :beforeUpload="beforeUpload"
                                                  @change="handleReject"
                                                >
                                                  <span class="fa fa-file-import" style="font: 20pt;"/>
                                                  <p class="ant-upload-text">Click this area to upload</p>
                                                  <p class="ant-upload-hint">
                                                    Upload a zip file of your plugin resources here.
                                                  </p>
                                                </a-upload-dragger>
                                            </div>
                                            <div v-if="current == 2">
                                               
                                                <div class="row">
                                                    <!-- <div class="col-md-8"><h2 class="card-title">Form Builder</h2></div> -->
                                                    <div v-if="(viewJSONPretty == false && viewSampleJSON == true) || (viewJSONPretty == true && viewSampleJSON == false)" class="col-md-12"><button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="viewJSONPretty = false; viewSampleJSON = false;">Back to JSON Editor</button></div>
                                                    <div v-if="viewJSONPretty == false && viewSampleJSON == false"  class="col-md-12">
                                                        <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="viewJSONPretty = true; viewSampleJSON = false;">Preview</button> 
                                                        <button class="btn btn-sm btn-primary float-right mr-2" style="border-radius: 24px; border:0px; width: 20%;" @click="viewSampleJSON = true; viewJSONPretty = false">View Sample</button> 
                                                    </div>
                                                    <br><br>
                                                </div>
                                                <div v-if="viewJSONPretty == false && viewSampleJSON == false" class="row" style="overflow:scroll;">
                                                    <div class="col-md-12">
                                                        <base-input alternative="">
                                                            <textarea v-model="plugin.configuration" rows="15" class="form-control" />
                                                        </base-input>
                                                    </div>
                                                </div>
                                                <br><br>

                                                <div class="row col-md-12" v-if="viewJSONPretty == true"> 
                                                    <vue-json-pretty
                                                      :data="JSON.parse(plugin.configuration)">
                                                    </vue-json-pretty>
                                                </div>

                                                <div class="row col-md-12" v-if="viewSampleJSON == true"> 
                                                    <vue-json-pretty
                                                      :data="defaultConfig">
                                                    </vue-json-pretty>
                                                </div>
                          
                                            </div>
                                        </div>
                                </div>
                                <div v-else>
                                    &nbsp; &nbsp; <small>Please select a plugin to edit or click "New" button.</small>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="card mb-3">
                        <div class="row no-gutters" style="height: 70vh; max-height: 70vh;">
                        <div class="col-md-4" style="border-right: 1px solid #e0e0e0">
                          <div class="card-body">
                            <div class="row">
                                <div class="col-md-8 no-gutters"><h3 class="card-title">Backend Plugins</h3></div>

                                <div v-if="formVisble == false" class="col-md-4 float-right"><button @click="showPluginForm()" class="btn btn-sm btn-primary" style="border-radius: 24px; background-color: #0569FF; border:0px; width: 100%;"> + New</button></div>
                                <div v-if="formVisble == true" class="col-md-4 float-right">
                                    <a-popconfirm title='Are you sure you want to cancel?' class="btn btn-sm btn-danger" style="border-radius: 24px; border:0px; width: 100%;" @confirm="() => showPluginForm()">
                                        Cancel
                                    </a-popconfirm>
                                </div>

                                <div class="col-md-12">
                                    <ul v-if="backendPlugins.length > 0" class="list-group" style="width: 100%">
                                        <li class="list-group-item" style="font-size: 14px" v-for="backendPlugin in backendPlugins" :key=backendPlugin.id @click="getBackendPlugin(backendPlugin.id)">
                                            {{backendPlugin.name}} <br>
                                            <small>Author: {{backendPlugin.author}}</small>   
                                        </li>
                                    </ul>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-8">
                          <div class="card-body">
                             <div class="row">
                                <div class="col-md-8"><h3 class="card-title">Backend Plugin Configuration</h3></div>
                                <div v-if="formVisble == true" class="col-md-3 steps-action">
                                    &nbsp; &nbsp;
                                    <button class="btn btn-sm btn-success float-right" v-if="plugin.id == undefined" type="primary" @click="createBackendPlugin()" style="border-radius: 24px; border:0px; width: 50%;">
                                        Save
                                    </button>
                                    <button class="btn btn-sm btn-success float-right" v-else type="primary" style="border-radius: 24px; border:0px; width: 50%;" @click="updateBackendPlugin()">
                                        Update
                                    </button>
                                </div>
                                
                                <div class="col-md-12" v-if="formVisble == true" style="padding: 15px; width: 100%; max-height: 56vh; overflow: scroll;">
                                    <div class="row">
                                        <base-input required alternative="" label="Name" v-model="plugin.name" class="col-md-6"/>
                                        <base-input required alternative="" label="Version" v-model="plugin.version" class="col-md-6"/>
                                        <base-input required alternative="" label="Author Name" v-model="plugin.author" class="col-md-6"/>
                                        <base-input required alternative="" label="Company Name" v-model="plugin.company" class="col-md-6" />
                                        <base-input required alternative="" label="Redirect Link" v-model="plugin.redirect_link" class="col-md-12" />
                                        <base-input v-if="plugin.id != undefined" alternative="" label="App Key" v-model="plugin.app_key" class="col-md-12" disabled/>
                                    </div>
                                </div>
                                <div v-else>
                                    &nbsp; &nbsp; <small>Please select a plugin to edit or click "New" button.</small>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import ValidateField from '../../components/validateFormUtils.js'
    import axios from "axios";
    import VueJsonPretty from 'vue-json-pretty'
    import { mapState, mapActions } from 'vuex'
    var component_x;
    export default {
        components:{
            VueJsonPretty
        },
        mounted: async function(){  
            component_x = this;
            var response = await HTTPRequest.getRequest(this.endPoint + "/pos_plugins", null)
            this.posPlugins = response.data
            var response = await HTTPRequest.getRequest(this.endPoint + "/backend_plugins", null)
            this.backendPlugins = response.data
        },
        computed: {
             ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        data() {
          return {
            errors: [],
            modalVisible: false,
            pluginKey: 0,
            posPlugins: null,
            backendPlugins: null,
            viewSampleJSON: false,
            viewJSONPretty: false,
            drawerVisible: false,
            selectedPlugin: null,
            selectedProfile: "pos_plugins",
            formVisble: false,
            defaultConfig: {"permissions": [
                    {
                        "model": "<insert-model>",
                        "methods": [
                            "<insert-methods>"
                        ]
                    }
                ],
                "events": [
                    {
                        "event": "<insert-event>",
                        "priority": 1,
                        "blocking": "true/false",
                        "functionName": "<insert-function-name>"
                    }
                ]
            },
            plugin: {version: "1.0.0"},
            accessRights: [ {code: "R", label: "Read"},  {code: "W", label: "Write"}, {code: "D", label: "Delete"}],
            validModels: [ {code: "products", label: "Product"}, {code: "customers", label: "Customer"}, {code: "x_readings", label: "X Reading"}, {code: "z_readings", label: "Z Reading"}],
            validEvents: [ {code: "onMenuPress", label: "On Menu Press"}, {code: "onLogin", label: "On Login"}, {code: "onSignout", label: "On Signout"}],
            fileList: [],
            current: 0,
            steps: [  {title: "Information", description: "Provide necessary information"} , {title: "Resources", description: "Upload zip file of your plugin source code here."}, {title: "Configuration", description: ""}]
          }
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            validateBackendForm(){
                this.errors = [];
                this.errors.push(ValidateField.required('Name', this.plugin.name));
                this.errors.push(ValidateField.required('Version', this.plugin.version));
                this.errors.push(ValidateField.required('Author', this.plugin.author));
                this.errors.push(ValidateField.required('Company', this.plugin.company));
                this.errors.push(ValidateField.required('Redirect Link', this.plugin.redirect_link)); 
                this.errors = _.compact(this.errors)
                return this.errors.length;
            },
            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.required('Name', this.plugin.name));
                this.errors.push(ValidateField.required('Version', this.plugin.version));
                this.errors.push(ValidateField.required('Author', this.plugin.author));
                this.errors.push(ValidateField.required('Company', this.plugin.company));
                this.errors.push(ValidateField.required('Configuration', this.plugin.configuration)); 
                if(this.plugin.id == undefined){
                    this.errors.push(ValidateField.required('Source', this.fileList[0])) 
                }
                this.errors = _.compact(this.errors)
                return this.errors.length;
            },
            setCurrentProfile(profile){
                this.selectedProfile = profile
            },
            showPluginForm(){
                this.formVisble = !this.formVisble,
                this.current = 0
                this.plugin = {}
            },
            handleRemove(file) {
              const index = this.fileList.indexOf(file);
              const newFileList = this.fileList.slice();
              newFileList.splice(index, 1);
              this.fileList = newFileList;
            },
            beforeUpload(file) {
               this.fileList = [...this.fileList, file];
               return false;
            },
            handleReject(file){
                var latestUpload = this.fileList[this.fileList.length - 1]
                var fileExtension = latestUpload.name.split(".").pop()
                if(fileExtension != "zip"){
                    this.$notification['error']({
                        message: 'Unsupported file type',
                        description: "Upload .zip files only."
                    });
                    this.handleRemove(file)
                }  else {
                    if(this.fileList.length > 1)
                        this.handleRemove(this.fileList[0])
                }
            },
            async getPlugin(pluginId){
                var response = await HTTPRequest.getRequest(this.endPoint + "/pos_plugins/" + pluginId, null)
                this.plugin = response
                this.formVisble = true
            },
            async getBackendPlugin(pluginId){
                var response = await HTTPRequest.getRequest(this.endPoint + "/backend_plugins/" + pluginId, null)
                this.plugin = response
                this.formVisble = true
            },            
            async createPlugin(){
                var errorCount = this.validateForm()
                if(errorCount > 0){
                    this.$notification['error']({
                        message: 'Failed to create plugin',
                        description: this.errors.join(", ")
                    });
                } else {
                    var bodyFormData = new FormData();
                    var pluginDetails = {pos_plugin: this.plugin}                
                    axios({
                        method: 'post',
                        url: this.endPoint + "/pos_plugins" ,
                        data: pluginDetails,
                        headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
                        })
                        .then(function (response) {
                            //handle success
                            console.log(response);
                            var posPluginID = response.data.id
                            bodyFormData.append('file', component_x.fileList[0])
                            axios({
                                method: 'post',
                                url: component_x.endPoint + "/pos_plugins/" +  posPluginID + "/upload_source",
                                data: bodyFormData,
                                headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"}
                            })
                            .then(async function (response) {
                                if(response.data.error == undefined){
                                    component_x.plugin = {}
                                    component_x.formVisble = false
                                    component_x.current = 0
                                    component_x.fileList = []
                                    component_x.$notification['success']({
                                        message: 'Succesfully created plugin',
                                        description: "Your plugin is ready for activation for BXI accounts."
                                    });
                                    var response = await HTTPRequest.getRequest(component_x.endPoint + "/pos_plugins", null)
                                    component_x.posPlugins = response.data
                                }else{
                                    axios({
                                        method: 'delete',
                                        url: this.endPoint + "/pos_plugins/" + posPluginID ,
                                        headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
                                        })
                                    .then(function (response) {
                                        if(response.data.message == "Okay"){
                                            this.$notification['error']({
                                                message: 'Failed to create plugin',
                                                description: "Error on uploading source code. Please try again."
                                            });
                                        }
                                    })
                                }
                            })
                        })
                        .catch(function (response) {
                            console.log(response);
                    });
                }
            },
            preUpdatePlugin(){
                if(this.fileList.length > 0){
                    this.modalVisible = true
                } else {
                    this.updatePlugin()
                }
            },
            async updatePlugin(){
                var errorCount = this.validateForm()
                if(errorCount > 0){
                    this.$notification['error']({
                        message: 'Failed to update plugin',
                        description: this.errors.join(", ")
                    });
                } else {
                    var response = await HTTPRequest.putRequest(this.endPoint + "/pos_plugins/" + this.plugin.id , null, this.plugin)
                    if(response.error == undefined){
                        if(this.fileList.length > 0){
                            var bodyFormData = new FormData();
                            bodyFormData.append('file', this.fileList[0])
                            axios({
                                method: 'post',
                                url: component_x.endPoint + "/pos_plugins/" +  this.plugin.id + "/upload_source",
                                data: bodyFormData,
                                headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"}
                            })
                            .then(async function (response) {
                                component_x.postUpdatePlugin()
                            })
                        } else {
                            this.postUpdatePlugin()
                        }   
                    }
                }
            },
            postUpdatePlugin(){
                this.fileList = []
                this.formVisble = false
                this.plugin = {}
                this.current = 0
                this.modalVisible = false
                this.$notification['success']({
                    message: 'Succesfully updated plugin',
                    description: "Your plugin update is ready for download for BXI accounts."
                });
            },
            closeModal(){
                this.modalVisible = false
            },
            async createBackendPlugin(){
                var errorCount = this.validateBackendForm()
                if(errorCount > 0){
                    this.$notification['error']({
                        message: 'Failed to create plugin',
                        description: this.errors.join(", ")
                    });
                } else {
                    var backendPlugin = {backend_plugin: this.plugin}
                    var response = await HTTPRequest.postRequest(this.endPoint + "/backend_plugins/", null, backendPlugin)
                    if(response.id != undefined){
                        this.$notification['success']({
                            message: 'Succesfully created plugin',
                            description: "Your plugin is ready for installation for BXI accounts."
                        });
                        this.plugin = {}
                        this.formVisble = false
                        var response = await HTTPRequest.getRequest(this.endPoint + "/backend_plugins", null)
                        this.backendPlugins = response.data
                    }
                }
            },
            async updateBackendPlugin(){
                var errorCount = this.validateBackendForm()
                if(errorCount > 0){
                    this.$notification['error']({
                        message: 'Failed to update plugin',
                        description: this.errors.join(", ")
                    });
                } else {
                    var backendPlugin = {backend_plugin: this.plugin}
                    var response = await HTTPRequest.putRequest(this.endPoint + "/backend_plugins/" + this.plugin.id, null, backendPlugin)
                    if(response.id != undefined){
                        this.$notification['success']({
                            message: 'Succesfully updated plugin',
                            description: "Your plugin changes are ready for BXI accounts access."
                        });
                        this.plugin = {}
                        this.formVisble = false
                        var response = await HTTPRequest.getRequest(this.endPoint + "/backend_plugins", null)
                        this.backendPlugins = response.data
                    }
                }
            }
        }
    }
</script>

<style scoped>
</style>


